// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-card ion-card-content ion-row {\n  align-items: center;\n}", "",{"version":3,"sources":["webpack://./src/app/components/modena/modena.component.scss"],"names":[],"mappings":"AAEQ;EACI,mBAAA;AADZ","sourcesContent":["ion-card {\n    ion-card-content {\n        ion-row {\n            align-items: center;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
